import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  SharedModule,
  FormInputComponent,
  BooleanCustomFieldConfig,
} from "@bb-vendure/admin-ui/core";
import {
  Observable,
  distinctUntilChanged,
  startWith,
  combineLatest,
  map,
} from "rxjs";

@Component({
  template: `
    <ng-container *ngIf="!(visibility$ | async); else NotfreeGift">
      <div>Event tag is not available for free gift or corporate product</div>
    </ng-container>
    <ng-template #NotfreeGift>
      <div [ngStyle]="{ display: 'flex', 'justify-content': 'space-between' }">
        <label> Toggle event tag on storefront </label>
        <input
          type="checkbox"
          clrToggle
          name="enabled"
          [formControl]="formControl"
        />
      </div>
    </ng-template>
  `,
  standalone: true,
  imports: [SharedModule],
})
export default class EventToggleComponent
  implements FormInputComponent<BooleanCustomFieldConfig>, OnInit
{
  ngOnInit(): void {
    this.isFreeGift$ = (
      this.formControl.parent?.controls as any
    ).freeGifts.valueChanges.pipe(
      distinctUntilChanged(),
      startWith(this.formControl.parent?.value.freeGifts)
    ) as Observable<boolean>;

    this.isCorporate$ = (
      this.formControl.parent?.controls as any
    ).isCorporate.valueChanges.pipe(
      distinctUntilChanged(),
      startWith(this.formControl.parent?.value.isCorporate)
    ) as Observable<boolean>;

    this.visibility$ = combineLatest([
      this.isFreeGift$,
      this.isCorporate$,
    ]).pipe(map(([result1, result2]) => !result1 && !result2));
  }
  readonly: boolean;
  config: BooleanCustomFieldConfig;
  formControl: FormControl;

  isFreeGift$: Observable<boolean>;
  isCorporate$: Observable<boolean>;

  visibility$: Observable<boolean>;
}
